<template>
  <div class="specific-message">
    <div v-if="loadFlag" class="loader-bg">
      <div class="loader-p" />
    </div>
    <div v-else class="email-template">
      <div class="email">
        <vue-custom-scrollbar
          :settings="settings"
          class="scroll-area"
        >
          <div class="email-content-wrap">
            <div class="email-top">
              <div class="email-info">
                <div class="email-sender-wrap">
                  <div class="email-sender_image">
                    <img v-if="content.image" :src="content.image" alt="Sender Image">
                    <img v-else src="@/assets/img/sender-default-img.svg" alt="Sender Image">
                  </div>
                  <div class="email-sender">
                    <p class="email-sender_name-wrap">
                      <span class="email-sender_name" v-text="content.sender" />
                      <svg
                        class="email-sender_icon"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <rect width="16" height="16" fill="url(#pattern0)" />
                        <defs>
                          <pattern
                            id="pattern0"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use xlink:href="#image0_10735_1145" transform="scale(0.00195312)" />
                          </pattern>
                          <image
                            id="image0_10735_1145"
                            width="512"
                            height="512"
                            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAIABJREFUeJzs3Xl4VPW9P/D358xClpkQdhWEJKAoiAio1V67aGtrq3WrUq3VimJDEqQu1y73d29L7XJrFxckCbhW6SZal2pva62Vtu4KuIFIQxZEZSfJTLaZOefz+wOirCHLnPnOOfN+PU+fR8jMOe+S5Hzec1YBEWW1GYs1tDnRPiJg6UgBRsLSYiiKFToEahVbosWOYLAoCgEUQFEIQRjAYECCgA7ea5ERAKG9/i4JIL7nX0kzoDaAFigSELQBaFdBGxTNgDRDnWYRaQawA5Y0A9icSsqW8dsKNi+bLyk3/j2IKD3EdACiXDZhQWxEMmSNsdQ+HCJjRWWMqo6BYLQAIxUYgZ3/86ItCmwWYAugGwTWeyq6AY42Kax3w0Fnw9ryoq2mQxLlKhYAIjct1cC4TS1jrVBwgjo6XlQniMh4BSYAGA8g33REwzogqBPFOoXWqUidpbLOkWRd46bi9ZgvjumARH7FAkCUJoff3nZYKKCTHMVkEZ0EYDIgxwFaaDqbRyUEqFNglShWq2BVwMHqupGRNZgptulwRF7HAkDURzMWa6glGT/SFpkB6AwIZgCYBqDAdLYckRTg3wpdrmott+As7wxGV7xfLu2mgxF5CQsAUU+WaqBsU9skDTgfA6yTIHoiFEcDCJqORntIAVgN4GWovmhZ8tK6TZHVPIRAdGAsAES7mbBgW5ETzjtFHec/BDhZgeMBRE3non5pheAVAC86aj2XN6j92XeuHBEzHYooW7AAUE6bePeWaLIr/2MAPqvQUwCciH0vkSN/sAV4R4FnAfwtFNBneBUC5TIWAMopY27W/FBB2ylwcDqgpwOYCv4e5CoHwOsi8hQUTzn5hc82zpJO06GIMoUbPvK90kXxqWo7nxeR0wGcAiDPdCbKSh0A/gWVp8TBk/VXR940HYjITSwA5Dsl92qe1dF2iqp+CYJzAYw1nYm8SJsAeRKqT2hB9CnuHSC/YQEgXxi9sHXYoADOUcjZUPksr72n9JI2Uf2rA/1japD+ccPswdtNJyIaKBYA8qwjF7cOT6asL0JwIaCfB0/eo8ywAbyoKg9qUJY2lRd+YDoQUX+wAJCnlN4ZH4WkzgQwE8DHAViGI1FusyF4DoqlgRSW1s2LbjEdiKi3WAAo6425WfNDefGzALmMn/Qpi9kAXgRwf3hQ5+94zwHKdiwAlJU+PV+D60fFzlBHLoXgS+BDc8hb2gX4I+D8un540V/47ALKRiwAlFVKa1onisrFKpgFnr1P/vABFA9C5O6GysgbpsMQdWMBIOMm3r0lmugcdBEgsyA42XQeIhc9B9V7C9D5wKqqkXHTYSi3sQCQMSWLW4+ybOtyhX4DwBDTeYgyKAbgd7CkpmFO5HXTYSg3sQBQRk1equH2rfFzAHwDwGdN5yHKAssB3JHsjCzZcJ10mA5DuYMFgDLi8NvbDgsGnUoovgFghOk8RFloM4A7nIBVw3sLUCawAJCrxi1sm25ZTjmAy8B78BP1RgLAY46ltzTNKXrBdBjyLxYASr/5apWOiJ+vgmtl5816iKh/nhXFLfVbIo9ivjimw5C/sABQ2kxequH2LW0XAfpdCI4ynYfIR+pVZQEKChfzoUSULiwANGAT794S7erMv8ISvUGB0abzEPmWYpMAi5xE6tbGa4c0m45D3sYCQP025q6WoaGEdS2AqwEMNp2HKIc0C7AgBfvW9ZXFO0yHIW9iAaA+G72wddggkatV8E0AxabzEOWwuECqE2H7Z3xEMfUVCwD12pGLW4enUjJXBdeAn/iJskkcinsQlp80XBXZZDoMeQMLAB3U5OrNkTbJqxLId8HBT5TN4gKpRiDxv/XlQ1tMh6HsxgJAB7Trrn2XQ3EjBKNM5yGiXtum0J8jP3obrxqgA2EBoH18er4Gm0bEZsGS70ExxnQeIuq39SL6g/ph0fv4SGLaGwsA7aGsJv5ZFb0ZiimmsxBRmijWOGJd11RZ+GfTUSh7sAAQAGDsotgky9afi8gXTWchIrfIE4FA6pq68uJ1ppOQeSwAOW5MbfvoMJwfqeplACzTeYjIdV0icpuV7Ppx3bxhrabDkDksADlqxmINbUu1VYroDwFETechoozbpio/bBxRuJDnB+QmFoAcVLYw/hlYukCBSaazEJFxK+Hgmoa50X+aDkKZxQKQQyYsbh5v24H/BXCh6SxElG3kCcdOzWu6urjBdBLKDBaAHDBjsYa227EbAPkfAHmm8xBR1upQ1fklW6I3L5svKdNhyF0sAD5XUh0/TkTvAjDDdBYi8ow3RK3Z9VWFr5gOQu5hAfCpMTdrfjiv7fsK/U8AAdN5iMhzUlDUtLe3/demGw5pMx2G0o8FwIdKF8Y+CQt3AjjSdBYi8rx6gZTXV0b+ZjoIpRcLgI+U3LKjWAYFbwJwFfi9JaL0ejDhaMV7c4u2mQ5C6cEh4ROl1a1fEpFaBUabzkJEPqXYBMi3Gqoi95uOQgPHAuBxY2rbR4fUWQToWaazEFGOEDzmWFZFU3nhB6ajUP+xAHjYuNrW8yyVOwEMM52FiHJOswoqGiuivzcdhPqHBcCDxtys+aFB8Z9CMM90FiLKdbqkQDsrV1WNjJtOQn3DAuAxZYvajlfH+Q14hj8RZQ1pcCznkqY5RS+YTkK9xwLgFapSUtM2T0R/BiBsOg4R0V5Sovhx/YjID/lwIW9gAfCAssUdY9VO3Q/gU6azEBH1SPGC49iX8JkC2Y/Pf89ypdWxC9ROrQSHPxF5geBkKxBYWVYbv8R0FOoZ9wBkqQkLthXZwdBCQC41nYWIqD9E5Ff5TvvVPEEwO7EAZKHSmtaJAnlYgUmmsxARDdDagIPz6+ZGV5kOQnviIYAsU1rTejYgL3H4E5FPHGlbeKG0OnaB6SC0J+4ByBZLNVC2te3HCv0W+H0hIv9RKG4ftyVy/bL5kjIdhjhossKRi1uHJ1PyWwhON52FiMhl/0BIvtJwVWST6SC5jgXAsHEL26Zblv4B0BLTWYiIMkKwQW3ngsa5g18yHSWX8RwAg0qr45dZlvMshz8R5RTFGLGsf5RWt15lOkou4x4AAyYs0EF2KH47FPzhJ6Icp0uSndHyDddJh+kkuYYFIMMOv73tsGDAfhSQE0xnISLKDvKSKs5trIpsNJ0kl7AAZND42tgxjuJPAMaazkJElE0EeM9ROauxKvKa6Sy5gucAZEhZTfyzjuJZcPgTEe1DgdEi+s9xNW1fMJ0lV7AAZEBZTesshf4fgMGmsxARZbGoBeePJbWxctNBcgELgJtUpaw6Nl8h9wAImY5DROQBQVEsKq2O3QZVHqZ2Ef9xXTJhgQ6yA/G7IeATsYiI+udBzY9c1jhLOk0H8SMWABeMuatlaChhPQw+wpeIaEAUeD4c0HPWlhdtNZ3Fb1gA0mxsTXNZQAN/guAo01mIiHyiTizni/VzBv/bdBA/YQFIo9LalhOh1hMARpjOQkTkK4pNllhnrqssXG46il/wJMA0KamNfRpqPQUOfyKi9BOMcuAsG1cdO9V0FL9gAUiD0urWL4nizwCKTGchIvKxiCV4orQ6/jnTQfyABWCASmviX4PIwwDyTGchIsoBBRB9fFxt63mmg3gdC8AAlFXHrwX0fgBB01mIiHJI2FJ5oKQ69hXTQbyMBaCfSmtab1DRm8ETKYmITAiJ4Del1a1Xmg7iVSwA/VBS0/ptQH5mOgcRUY4LQOTOkpr4NaaDeBELQB+VVcfmC+SnpnMQEREAQAR6S0lt7Pumg3gNd1/3QWlN7IcA/tt0DiIi2pdAbqqvjHzHdA6v4B6AXiqtif0YHP5ERFlLod8urY7daDqHV3APQC/wkz8RkXeI6HfrK4p4qPYgWAAOoqQm9j0BfmA6BxER9Z5Arq+vjNxsOkc2YwHoQWlt/Hqo/sJ0DiIi6jOFanlDVdGdpoNkKxaAAyipiV8j0FtM5yAion6zVXFJY1X0AdNBshELwH6U1sYvhep94L8PEZHXJaH65YaqosdNB8k2HHB7KVnYeo5Y8hB4e18iIr9IOLDObaos/LPpINmEBWA342tjpzmKP4EP9iEi8pt2OPhCw9zoP00HyRYsALuU1racCLWeBhAxnYWIiFzRYsH6zLrKwuWmg2QDFgAA425vLrUCgRcBjDSdhYiIXLXVUufkdVWD60wHMS3n7wQ45q6WoVYg8Gdw+BMR5YLhDqzHx9Y0DzEdxLScLgCTl2o4mLAeBDDRdBYiIsoQwVEBCTw6YYEOMh3FpNwtAKrSvjV2lwCnmY5CREQZpvikE4z/Cqo5eyg8ZwtAaW38R4BcajoHERGZocBFZTXxnH2McE42n7La1itU5W7TOYiIyDhVyKzGysh9poNkWs4VgJLa2KdF8SSAsOksRESUFZIC+WJ9ZeRvpoNkUk4VgLGLYpMCDp4DUGw6CxERZZVWseWU+qsjb5oOkik5UwDGLW471LKdFwGMNZ2FiIiykTSq4uTGqshG00kyISdOAiy5V/Ms234MHP5ERHRAWiKij+TK5YE5UQCko20hICeYzkFERFnvJCcQv810iEzw/SGA0prYNwAsNp2DiIg8RHV2Q1WRr68W83UB2PWAn38CyIndOURElDadYlmfqJ9T+KrpIG7xbQEYvbB1WNiyXgW0xHQWIiLypPWhgM5YW1601XQQN/jzHIClGghb8lsOfyIiGoCxSUd+j6UaMB3EDb4sAKVbYz8F8DnTOYiIyOMUnyndGr/RdAw3+O4QQElN67kCeRg+/P9GRERGKBQzG6qiD5kOkk6+GpKlNa0TAXkZQJHpLERE5Csx28JJ6+dEV5sOki6+OQQwYcG2IkAeA4c/ERGlXzTo4MHJ1ZsjpoOki28KgB0MLQQw0XQOIiLyJwUmtUvBraZzpIsvDgGUVscugOBB0zmIiMj/VHFRY1X0AdM5BsrzBWDCgvYxdtB+HcBQ01mIiCgnNEsgOLW+PH+96SAD4e1DAPPVcoL2/eDwJyKizClWJ7XE6/cH8HQBKB0R/64Cp5rOQUREOUbxyZItsetNxxgIzx4CGF/TNsOB8zyAsOksRESUk5IQ55SGisEvmw7SH57cAzDq5xsLHTi/AYc/ERGZE4Jav/HqpYGeLAAFhZHbwEv+iIjIvAkdkv9z0yH6w3OHAMbVtp5nqTxsOgcREVE3dfTcxrlFj5nO0ReeKgBjattHh9R+HcAw01mIiIh2s9UJWMc2lRd+YDpIb3nqEEAIdjU4/ImIKPsMt2y903SIvvBMASipjV0ExTmmcxAREe2fnllWE/+q6RS95YlDAGPuahka6rJWQzDKdBYiIqIebENIJjdcFdlkOsjBeGIPQCghN3P4ExGRBwxDShebDtEbWb8HYFx17FRL8DQ8kJWIiAgAoLiwoSr6kOkYPcnqoXrYYi0I2/E3BBhvOgsREVGvKTbZYh+9vrJ4h+koB5LVhwAG2bEfcvgTEZHnCEYFEfiJ6Rg9ydo9AGXVbSeoOC8A8PTTloiIKGc5luon1lUVPW86yP5k5R6AT8/XoIqzGBz+RETkXZYjsnjGYg2ZDrI/WVkAmkbGvgVgmukcREREA3TMNjt2nekQ+5N1hwAmLG4eb9uBtwDkmc5CRESUBu1wgpMa5uY3mQ6yu6zbA2DbwVvA4U9ERP5RgEDqF6ZD7C2r9gCUVsc/B9EnTecgIiJKNxU5o7EikjUzLmv2AExeqmGILjCdg4iIyA2ieks2nRCYNQWgY2vsegATTecgIiJyydE77LarTYfolhWHAMbUto8Oqb0GQMR0FiIiIhe1IiRHZsPDgrJiD0BIUz8Ghz8REflfEZJ6o+kQQBbsAShdFJ8KR1cgS8oIERGRy2yxZVr91ZE3TYYwP3Qd/UVW5CAiIsqMgBPQW02HMDp4y2pbzwLwWZMZiIiIMk2A00pq4583mcFYAfj0fA2qys9MrZ+IiMgkUf0FlqqxZ94YKwBNI+NXADja1PqJiIgMO6ZkS+xSUys3chJgyb2aJx3xtQAON7F+IiKi7KBNgVR0Yt086cr0mo3sAZD2trng8Cciopwn41KheLmRNWd6hRPv3hJNdOXVARiZ6XUTERFloS3hQZ3j37lyRCyTK834HoBEV963wOFPRETUbUSiK++bmV5pRvcAHLm4dXjSlnoA0Uyul4iIKMu12LBL11cW78jUCjO6ByBlW/8JDn8iIqK9DQ4icE0mV5ixPQCjF7YOC1vSABYAIiKi/Wm1YZdkai9AxvYAhCzrenD4ExERHUhRUAMZOxcgI3sAxtzVMjSUsBrBAkBERNSTjJ0LkJE9AKGkdR04/ImIiA5msCWBeZlYket7ACYs2FZkB8NNAIrdXhcREZEP7CjQjrGrqkbG3VyJ63sAnFCoEhz+REREvTWkXfJnub0SV/cATFigg+xgvAHAoW6uh4iIyF+kYdzmwiOXzZeUW2twdQ9AKhS/HBz+REREfaSlTSPj57m5BvcKwFINiOJ615ZPRETka3qDm0t3rQCUbomfB+AIt5ZPRETkb3JCWXXrKW4tPejWggFc5+KyyaCyYgtHDLFQWmxhZKGgIAhEwhl/sCRRzoonFG1JYHO7or7ZwdrtDppaHNOxyA0i1wN41pVFu7HQ8TVtMxw4r7qxbMq8vCDwmXFBfL4siJNGBzA8n8OeKNtsblc8v8HGU40pPN2YQsI2nYjSRB3F5Kaq6NvpXrArewBsONdxRHjf4UUWZk8N4bwjg/yET5TlRhYIzj0yiHOPDKKlS/HI2hTuei2B9+NqOhoNjAQE8wBUpH3B6V7g4be3HRYMOA0AwuleNmXGiALBDR8L47wjQwhk9HmRRJROSQd4aE0Sv3w5ge0dLAIe1omQlDRcFdmUzoWmffMeDDhV4PD3JAFw6TEh/O3iAlxwFIc/kdeFLODiSTt/py+aFMrc418p3fI0pXPSvdC0/jzsuvHPuwBGpHO55L6h+YKfnzoIp45z87xQIjLpyYYUvv1MF1q7uDfAgzYHUpGxdfOkK10LTOtnPDvYdiE4/D1nfLGFR87P5/An8rnPlwbx2JfzMbaIu/c8aKQTaDs/nQtM60+BQtN+kgK569iRFpael4/DuUEgygnjBlt46Px8TB7O33mvUSu9hwHSdgigtCZ+LKCvp2t55L6Jwyz89ux8DMnjkUGiXLOjU/GVRztQt4P3D/ASSzBlXUX0rbQsKx0LAQDhp39POaRQcP9ZHP5EuWpInuDeM/MxsoDbAC9xHFyVrmWlpQBMrt4cUeCr6VgWuS9oAQtOz8MI/uIT5bTRUcFtp+chwE2Bdwi+PurnGwvTsai0FIB25F0MoCgdyyL3XXdiGMcfGjAdg4iywMcOC2DuDF657SGD8wsKLkzHgtJzCEDkirQsh1x31DALs6fyl52IPlI5I4wJQ3hSoFeIJbPSsZwBf8dLa1onAvhYGrJQBvzwk4MQ5O85Ee0mZAHzTxlkOgb1luIT46tbJgx0MWkYBdaVcOmhQpRenx4bwIxDuOufiPb18TEBnDya2wePEMeyLh/oQgZUAD49X4OAfm2gISgzeJyPiHpSNZ3bCK8QxeVYqgNqbAMqAE0jYl8AcOhAlkGZcdQwC9P56Z+IevDxMQEcMZTHCL1AgdEl29o+O5BlDOw7LXLpgN5PGXPRpJDpCETkAecewVuCe4U4OqAZ3O8CMPHuLVEAZw1k5ZQ5p5fwl5qIDu7MCdxWeIbIuZOrN0f6+/Z+F4CurvzzAeT39/2UOUcNs3BohOdpEtHBjS2y+GwQz9DCDhR8qb/v7vd3WaC8859H8Mx/IuoLXg3gHSq4uL/v7VcBGF8bGwngtP6ulDKLT/0ior44ehi3Gd6hZ4xe2DqsP+/s13fZBi4CwANFHnEkf5mJqA/G866AXhIKWdKvWwP367ssipn9eR+ZMSKfx/+JqPfGFnGb4TGZKQAl1fFDAJzcn5WRGcML2OaJqPciIRYALxHgU7sOzfdJnyeDBT2/P+8jc674UwdefN82HYOIPCI6iAXAYwKO6tl9fVOfB7kj+HJf30NmvfS+ja8+1oGLH+vAC++xCBBRz179gNsJD+rzbO5TzRu9sHVY2JKN4AmAnjbjkAAqpodw2jh+G4noI8s32rj55QQ/KHhT0oY9an1l8Y7evqFPE2CQhbOVw9/zlm+0Mfv/bBYBIgIAPLfBxi9fTuC1TRz8HhYKSPAsAEt6+4Y+bfkVcm6fI1HW6i4C0w8JoJJFgCinKIBnmlK47ZUE3tzimI5DaaFnow8FoNeHACYs0EF2ML4VQL/vO0zZjUWAyP8cBZatT+GWlxNYtZWD32figVRkeN086erNi3u9pXfC7Z+Bw+HvZyu4R4DItxwF/lK/c/Cva+bg96mIE2z7BIC/9ebFvS8AjnMWLwzJDR8WgVEBVM5gESDyspQDPF6Xwu2vJtDYwsHvf3omelkAej3TS2taGwEZ199I5F0sAkTek3SAh9YksXB5Ah/E1XQcypz6hsro+N68sFcFoLQmfiygrw8sE3kdiwBR9mtPKpauSeGOlQlsbOPgz0Ua0KMby4vWHOx1vdqSqzpniPAAQK5bsYmHBoiyVffgX7Qigc3tHPw5zbbOAJCeAiAipw84EPlGdxGYNiqAKhYBIqPakoolbyVxx8okmrs4+AmAOqcDuPVgLzvox/qSezVPOuLbAeSnIxf5T3cROHVcsG+3liSiftvRqbj/rSTufSOJVg5+2oO0BVKFww52OeBBP7pJe9snIRz+dGArd+0RmDTcQuX0ML4wnkWAyC3bOxRLViVxz+tJxBIc/LQ/WpgKxU8GsKynVx183604p/fxkQGUo1ZvdTD3r504epiFqhksAkTptLVDcc/rSdz3ZgIdKdNpKNuJ4nQcpAAcdPtcWhN7DcDUNGWiHMIiQDRw78cVd7+ewO9WJ9HJwU+9pq80VBad2NMretwuj7mrZWgoYW1BPx4bTNSNRYCo7zbEHNz7RhK/WZVEgs/oob5ztCs1rPHaIc0HekGPhwCCCfkkOPxpgN7exkMDRL21vtXB4pVJLF2ThM0b91H/WdYg6z8A/OlAL+j5HADBJ8FzTChNuovAUcMszGURINrD2u0O7ngtgcfWpmBzu0vpIIFPor8FwIJ8ij+HlG5rWASIPrRmm4O7Xk/g0bUpONzgUhqp4lM9ff2A290JC7YV2cHwdgCBtKci2g2LAOWiVVsd1K5I4M/rUtzRSm5JhQd1Dn3nyhGx/X3xgHsAnHDeKXAcDn9yHfcIUC5ZvtHGopVJPN3IU/rJdcFEMv8kAE/t94sHepfj6CncCFMmdReBicMsXM0iQD6zfKONW19J4LkNPKWfMsjWT6CvBcCCnsTdUmTCOywC5CPPbbBx88sJrNzEwU8GCD524C/tz3y1SkfGdwAocisTUW+xCJDXKIBnmlJY8GoCb2zmtXxkVEvD5shQzJd9fhD3uz0trYkfC+jr7ueiTLh8Sgi/W51El8c/gLAIULZzFFi2PoVbX0ngrS0c/JQdbAuT18+Jrt777/d/kx91DrjLgLzne6cMwrJLCnH5lBDyPPzk3u5DA194oB2P8JIpyiKOAv+3LoUzHmjH7P/r9PzwH5LHiu0nQdWT9vf3+y8AYrEA+MyoQsH3ThmEf32tEHOmhT1dBNZud3D905344lIWATIr5QCPrE3h9N+3Y+5fO1G3w/uD/5snhLHskgLTUSiNVGW/M33/Y0D0RF6Y6k/D8gXfOimM2VNDuMvjTxbrLgKLV1oonxbGOUcEYfGDC2VA0gGeqNt5jL+pxdtDH9i5XbhyaghfnxJGvoc/HNAB7bcA7LO5LLlX86QjHkNvHhVMnlBfETng17Z3qOeLQLcjh+4sAmcfEUSARYBckLCBP7yTxO3LE9gY9/6npMMigtnHhXHR0fseHiyrjZsJRW5Ian6kqHGWdO7+l/tsJktrW06EWi9lLhe5racC0M1PReCIoRbmsAhQGrUnFUvXpLB4ZQKb2rw/+MdELVwxNYSLJ4Uw6AC3e2MB8BfHsWY0zS1csfvf7fMpX2FN4zYz9wz10aGBf+86NLBoJYsADUxbUvHgmhRqVySwpd37g39skYXyaSHMPCqEAJ/zmlMssacB6LkAWA6mKTeWOYtFgAiIJxS/XpXE4pVJtHR5f/BzrxhBZNref7XvHgDR6T08I4hyBIsA5aIdnYr730ri3jeSaPXB4D9qmIWrjuPPPAEK7FMA9vyRWKqB0q3xGID8TIUi9/XmHICD2d6hWLIqibtfTyKe8PaG8YghFuZM50aRPrKtQ3G3x4vu7iYNt1A5fWA3zeI5AL4Tb9gcGbz7HQH3+NkoW9h6pFryTuZzkZvSUQC6dX9CYhEgP/ggrrjr9QR+tzqJTh8M/hmHBFAxPYTTxg38Ii4WAP9xbLus6erihu4/7/FTYgcw2fL2Np1cNiRP8M3jw7jsmJDni8C/d+w6NLCCRSDXvBdT3PNGAr9d5f1bZAPA8YcGMGdaegY/+VcgaE0GsP8CYDkyiYf/qTdYBMiL1rc6WLwyiaVrkrC9f/8eHH9oANeeEMbJow9wLR/RbhwHkwA80f3nPQqACiZxu0d94cciULvCQgWLgK/8e7uDxa8l8Ni/U54f/ALgtJIg5s4IYepIDn7qPRFM2v3PexQAwZ5fJOotPxWBOhYB33hnm4M7X0/gsbUp2N78cfyQJcCp44L45vFhHDOCF/FTv+wx4z/arM1Xq3RkPA5eAeA76TwJsLf8dLLghzdPOTrEIuARq7c6qFmRwJ/XpTz/WBNLgDPKgrjmhDAmDMnc4OdJgL4Ub6iIFEFEgd0KwLjbm0utQKDeXC5yi4kC0K27CNzzehIxvxQB3kUtay3faGPRyiT+3uj9wR+0gLOPCKJyehhlxZn/gWMB8KdAKnB43byCDcBuhwCsUHACn6tK6bb3oQEvF4H1rQ7+3z+6sHhlkkUgy3QP/qcbvX8tX8gCvnREEFfPCGPcYP6LVPr8AAAgAElEQVSAUXqlQvYEAHsWAFGd4M3NMnmBH4vAopVJzGERMGr5Rhs3v5zAC+95/1q+cAD48sQQrp4RxiERHmsid4jqBADLgN0KgDo6HsIfOnKXn4rAuywCxjy3wcYvX07gtU3eH/wFIcFXjg7iG8eFMaqQ22Byl6o1vvu/P7oKwJIJnj9oRp7BIkB95SiwbH0Kt72SwJtbPH4tHz4a/HOmhTGigIOfMkMsndD93x/tAVBM4I8gZRqLAB1M9+C/5eUEVm31/uCPhAVfmxxC+bQQBg/iVpcyTPFhAdj506cqpbXxOIACU5nIPSavAugrPz2N7fAii0VgAFIO8HhdCtXLE6hv9v7gH5InuGxKCLOmhFDkgcHPqwB8K9ZQGS0CdhWACQtiI+wgNpvNRG7xUgHo1tyluO9NfxSBMVELFdNZBHor6QBP1KVw+6sJNLZ4f/APyxd87ZgQrjw2hEg4+wd/NxYA/7JhD11fWbwjCABJyzrcgvd/0cg/igftPDTw9SkhzxeBDbGdhwZqVyRZBHqQdICH1iSxcHkCH8S9+b3e3fB8wRVTQ7h8Shh5fEYPZZEAgocD2FkABPbh4FOAKAt1F4Erjw3h16uSWLSSRcBv2pOKpWtSuGNlAhvbvPm93d3oqODKqWFcPCmEQbxVP2WhnTMfb+wsAAE5nFcAUDaLhAVzpoVx6TEhLHmLRcAPugd/7YoEtrR783u5u+5zPi48KoRgDn4/yUPEGgvsugpAIIcrGwB5QGHIf0WgZkUCV04N46uTQgjnwCfGtqRiyVtJ3LEyiWaPfu92d8SQXY+RnhDMySJH3uOoHA7sKgCO6hgeACAv8VMReC+muPHZLtz9ur+LgJ+u8ACAicMsfOM4Pi2SvEfgfFQABDjMbByi/tm7CCxemUSLR4eLX4vA9g7FklXevsfD7o4eZqFqRhhfGB/kmVPkTSKHAh/dCGiUwShEA8YikH22dijueT2J+95MoMP7z+jB9EMCqJwewqnjOPjJ43TnzBcAKK2JbQMw1Gggco0X7wMwUN3Hmb1cBLp1n1XulSLwXkxxzxsJ/HZVEl3ev1U/jj80gDnTQjhtXG5dy8f7APja5obK6CiZsVhD2+14F3gdoG/lYgHo5qcicFhEMPu47C0C77Y6+NWbSfxmVRIJnwz+a08I4+TRWfiPnQEsAL7mjNscGSRjattHh9TeYDoNuSeXC0A3PxaBbLnOfH2rg8Urk1i6JgnbB/cT+48xAVx/YhjHjcqCf1yDWAB8LiSHyLjatmmWOitMZyH3sAB8hEUgfdZud3DHawk8tjYF29v/lBAAp5UEMe/4MKaM4LV8AAuA/8lUKa2Ofw6iT5qOQu5hAdhXe3LnJWl+uBY900Xg7W0O7n49gUfXpuB4+58OlgCnjgvimhPCmDycg393LAD+Jo58NqjQITz4T7mmYNdVA92PIfZyEXg/vvOqgbteS7haBFZsslG7Iom/N6Y8f9swS4AzyoK47sQwyoo5+CkHBbQ4CAvFnv9tJuonPxaBO19L4Ko0FoHlG20sWpnE043ev5YvZAFfOiKIuTPCKBnMwU+5S1WHBC3oEOUFAJTj/FQEPkhTEVi+0cYtryTw/Abvn9IfsoALjgph7owwDo1we0cEtYqDjmMNFvHmho4o3XYvAkvXpFCzPIGtHd78/ehvEXhug42bX05g5SbvD/6CkOArRwdx1XFhHFLIwU/0IdHBQUu02JubNyL3FIQEl08JYeZRwZwoAgrgmaYUFryawBubvX8tX/fgL58WxsgCDn6i/RgSdASDuQOAaP/8WARqlidwxdQQLp8SRjgALFufwq2vJPDWFu8P/sKQ4NJjQvjGtBCKB3HwEx2QojgoKhHwLECiHvmpCGztUPzsxQTufyuJgqCgvtn7g39InuCyKSHMmhJCEQc/0UGJoDAI0QLOf6Le8VMR2BhXeL38D83f+Yn/imNDiIY5+Il6S4GCoCry+WtD1Dd7F4HaFQlsaff2MPWS4fmCK6aG8PUpYeTn1jN6iNIlPyhAgekURF7FIpBZpm9/TOQjBUGwABANGIuAuw4vsjDr2FDWPgmRyIMKggDyTacg8gsWgfQaW2ShfFoIM48KIcAb9xGlkeQHAeSZjkHkNywCA3PkUAvl08I4+4ggAjxJiSj9VPODAHgKDZFL9i4Ci1YksJlF4ICOHmZh9nFhnHNEEBYHP5F7BEEWAKIMYBHo2fRRAVTOCOHUcUE+mYQoMwJBADylhihDWAT2dPyhAcyZFsJp4/g5hCjDgiwARAZ0F4GvHB3CA28nc64IHH9oANccH8bHx3DzQ2QI9wAQmZQfRE4Vgf8YE8B1J4YxbRQ3O0SGcQ8AUTboLgJfnRTCH95JYsGrCWxq80cREACnlQRx9Ywwjh3Ja/mIskSAB96Iskg4AFw8KYQvT/R+EbAEOHVcEN88PoxjRnDwE2WbIAAbvBKAKKt4uQhYApxRFsS1J4YxvpiDnyhL2SwARFnMS0UgaAFnHxFE1fQwSjn4ibJdqrsAEFEWy+YiELKALx0RxLzjwxhbxMFP5BE2CwCRh3QXgQuOCuGhNUnc/moCGw0VgXAA+PLEEK4+PoxDCnn7HiKPSQUBpEynIKK+CVnmikBBSPCVo4MonxbGyAIOfiKPslkAiDwsk0WgMCSYeXQQFdPDGJ7PwU/kabpzD0Cn6RxENDBuFoEheYLLpoRw+ZQQBg/i4CfyBZGOIIAO0zmIKD3SWQS6B/8Vx4YQDXPwE/mLdgQBtJuOQUTpNZAiMCxfcOXUEL4+JYx8XiBM5FftQQXa2e2J/GmfIrA8gY3x/ReBwyKC2ceFcdHRIeRx8BP5XXtQBB3IjsuJicglPRWBMVELV0wN4eJJIQzik0GIckVHECrtYAMgygndReDLE3c+fbAwJDjniCACvH8PUU4RoD2oonHh/CfKKeEAcOkxIdMxiMgQVbRZUDSbDkJEREQZJNhuAcICQERElEsUzRbUYQEgIiLKJZa0WCLcA0BERJRLBM4OC8JzAIiIiHKKI80WRHaYzkFEREQZpNJiqY0tpnMQERFR5khAN1kalE2mgxAREVFGbbZKPyjYAsAxnYSIiIgywl43LLLNWjZfUgC2m05DREREGaDYipliWwAgwGbTeYiIiCgDBJsAoPsRIDwPgIiIKDdsBnYVAAf4wGwWIiIiygz9ANhVACzIu2bDEBERUUaIrAd2FQCFsgAQERHlAAXeBT48B4AFgIiIKBdYYn1UABwJsAAQERHlAFHno0MAKdtebzYOERERZYJayY/2ALw3t2gbgHajiYiIiMhtrfXlQ1uAj+4DAAD1hsIQERFRZqzr/o8PC4AAdWayEBERUYZ8OOs/LAAKZQEgIiLyMYXsrwDIuv2/nIiIiPxA1NnPIQCLBYCIiMjPdLdZ/2EBcJIpHgIgIiLysWAysO8hgKZtg5sAdBhJRERERG6L112d/173Hz66DHC+OADWmEhEREREbpPVENHuP1l7fE2xOuN5iIiIyHUie874PQuAKAsAERGRD6k6By4ACu4BICIi8iOBHrgAWA4LABERkR/Zdg8FoH5kdB34UCAiIiK/ie+62u9De54DMFNsQN7MaCQiIiJy22u7rvb7kLX3KwS6MnN5iIiIKAP2me37FADdz4uIiIjIu0T0tb3/bt89AJa1IjNxiIiIKBNsBA6+B8BKFLwJIJmRREREROS2RChZsM9VfvsUgLp50gXg7YxEIiIiIret3jXb97BPAQAACF5yPQ4RERG5ToAX9/f3+y8AjrIAEBER+YCj+5/p+y0AliUsAERERH4Q7MMegHWbIqsBtLgaiIiIiNzW3PhBdO3+vrD/QwDzxYHgVVcjERERkcv0xb3vANht/wVgp/3uMiAiIiJvED3wIf0DFgBHrefciUNEREQZIfLsgb50wAKQN6j9WQApVwIRERGR25JtbfEXDvTFAxaAd64cEYPue+9gIiIi8gDFq5tuOKTtQF/u6RwAQPDPtAciIiIi14lIjzO8xwKgDgsAERGRJ1kDKACpPP0XgP1ePkBERERZy3Y6Es/39IIeC8CG2YO3A3g9rZGIiIjIZbK88dohzT29oudzAACIyFPpC0RERESuEz3o7D5oAYCCBYCIiMhDtBez+6AFwMkvfBZAR1oSERERkcukLZiKHPRuvgctAI2zpBOKA95JiIiIiLLKM3XzpOtgLzr4IQCgV8cSiIiIyDzt5czuVQGwRP48sDhERESUCaL6ZG9e16sCsK4i+hYgDQOLRERERG5SYF1DZdE7vXlt7w4BAIDqn/qdiIiIiFwn0Md6+9peFwCFsAAQERFlMUt6P6t7XQCCduEzAGL9SkRERERua80bFun1VXu9LgB186RLFH/rXyYiIiJyleIvq2ZKorcv7/05AAAc6B/7noiIiIhcJ/J4X17epwKAhP0ogF63CyIiIsqIhI1Un87V61MBaLx2SDMU/+hbJiIiInKXPLW+snhHX97Rtz0AANTCH/r6HjIr6ZhOQERewm2G9wicPs/mPhcACcqjAOy+vo/MaUuq6QhE5CGxLm4zPCYVDKBPx/+BfhSAhqsimyB4rq/vI3P4y0xEfRFLcJvhKYpn1pYXbe3r2/pcAHZ5sJ/vIwM2xPjLTES9t76V2wxPETzUn7f1qwAEkngAQKo/76XMW7eDB/SIqPfWNXOb4SGJhKP9OjevXwWgbl50C6C8KZBHvL2Nv8xE1Htvb+U2wzMEf35vbtG2/ry1v4cAALF+2+/3Uka98B7P2SSi3nvxfW4zvEId/K6/7+13AWiPxx8GpK2/76fMaWxx8B7PAyCiXljf6uDdVu4B8AZp62hve6K/7+53Adh0wyFtgPZ7xZRZT9QlTUcgIg94/N88vcs7nId3zuL+6f8hAAACZ8lA3k+Z8/A7/KUmooN7dC23FZ5hWQOawQMqAPXDi/4CwYaBLIMy4987HJ4LQEQ9enaDzSsAvEKwoWFo4d8HsogBFQDMFFtUfjOgZVDGVK/gc5yI6MCql3Mb4RkO7sVMGdCnuoEVAABwnHsA8AwzD3h+g829AES0X89usPESz/73Cg0E7fsGupABF4D6uUVrFXhhoMuhzPjvf3Yhwd9xItpN0gF+8K8u0zGo9/5RV168bqALGfgeAACiek86lkPua2h2ULuSu/mI6CMLX03w2L+XqNybjsWkpQAUoPMBAK3pWBa57/ZXE3huA3cDENHOm/7U8PwgL2nuChb2697/e0tLAVhVNTIOwa/TsSxyn6PA9U938uZARDluQ8zBvL92wuamwDNEcN/75dKejmWlpQAAgC2oBk8G9IzN7YqvPd6BbR38lhHloh2dillPdGIrtwGeYtm4M23LSteC1s+JrgbwXLqWR+5ranFw+RMd3AAQ5Zgt7YpLH+/gcX/vWVY3N7oqXQtLWwEAABFZlM7lkftWbXVw4SMdWM97fxPlhMaWnb/zq/nEP89RRVpnbFoLgJUsfAjAlnQuk9zX1OLgrAc78EQdbwFK5Gd/bUjhvD+w8HuSYlPhiMgj6VxkWgtA3TzpQpobCmVGPKGY91QnvrusC81dPCRA5Cc7OhXffqYLc/7SiRb+fnuSWqhdNVPSermGpHNhADBucduhlu00Agine9mUGUPyBNedGMbMo0MIpbUiElEmJWxg6dtJ3PJKAjs6Ofg9rEtVShqrIhvTudC0FwAAKK1pXQLI19xYNmXOoRHBlVPDOH9iEMWDXPlRISIX7OhUPPJOCne9kcDGOAe/1ynk3sbKyBXpXq4rW/VxC9umW5az3I1lU+aFA8CpY4M4vTSIj48O4JAIywBRtvkgrnj+PRtPNaTwTFMKSR7m9w1VmdZYFXkt3ct1bUteWhP7F4BT3Fo+mTO2yMKEIRbGDxGMLLAQCQPRMEsBUabEEop4Atjc7qBuh6Juh4N3eWKfLynw98bK6GfcWHbQjYUCgChuUWEB8KP1rQ7Wtzr4e5PpJERE/iaqt7q1bNdO8arfEnlUgNVuLZ+IiMjn3m7YEv2TWwt37xzv+eKo6s2uLZ+IiMjPVH6K+eLasR1XL/IaGozeD+BdN9dBRETkO4INBSMKf+/mKlwtAMvLJQmVBW6ug4iIyG/UkV+k+8Y/e3P9Ni/hvI7FAHa4vR4iIiKf2F6I9rvdXonrBeCdK0fEBLjd7fUQERH5guDWVVUj426vJjM3eg0kbwbQnJF1EREReVeLdqYy8qE5IwWgvnxoC4CFmVgXERGRVylwc+O1QzLygTljj3rRrtQvwb0AREREB9KCrlTGTpzPWAHY1WhqMrU+IiIiL1HBLZn69A9ksAAAQMLRmwG0ZnKdREREHrADnanbMrnCjBaA9+YWbVMB7w5IRES0G4H+PJOf/oEMFwAAKHQ6fgnFpkyvl4iIKEttDg3qyviJ8hkvAKuqRsZV5KeZXi8REVGWuvGdK0fEMr3SjBcAACgcXlgDSIOJdRMREWUPaQykIneZWLORArBqpiREnB+ZWDcREVHWUHy/bp50mVi1kQIAAPXDovcBeMPU+omIiAx7rWFE4W9MrdxYAcBMsR3FNcbWT0REZJAC12Cm2KbWb64AAGiqij4jwKMmMxAREWWcYmljZfQfJiMYLQAAkIJ9PQAjxz+IiIgM6FQr9W3TIYwXgPWVxfUiktG7HxERERn0i8aKIY2mQxgvAAAQCnf8CMAHpnMQERG5SYD3CrTjJtM5gCwpAO9cOSIG1f8xnYOIiMhNCvnOqqqRcdM5gCwpAADQsCV6L6CvmM5BRETkDnmpocLcZX97y5oCgPniWDsvC1TTUYiIiNJMRZ3/hEjWzLjsKQAA1lUVPQ/Fg6ZzEBERpZf+ur6q6FnTKXaXVQUAAKDBbwHoMB2DiIgoTeJJCX7XdIi9ZV0BaJib36TQH5jOQURElA4K+Z8NFQXvmc6xt6wrAABQsjn6SwDLTecgIiIaGH2lcXjh7aZT7E9WFoBl8yUFS64EkDSdhYiIqJ9SjgTKTd7vvydZWQAAoGFO5HURucV0DiIion76aVNF4UrTIQ4kawsAACQ6CucDqDOdg4iIqI/Wan7kx6ZD9CSrC8CG66RDBVeB9wYgIiLvUEtQ0ThLOk0H6UlWFwAAaKyILlOVe03nICIi6g0BFq+riP7ddI6DyfoCAABWMHGdAFl3CQUREdFePnC6Ull3zf/+eKIA1JcPbVHgWtM5iIiIeuKIVjVeO6TZdI7e8EQBAICGyuiDAjxqOgcREdF+CR5qqih6xHSM3vJMAQAAO2BVAthqOgcREdFeNiMoc02H6AtPFYCm8sIP1NHZpnMQERHtRqE6u+GqyCbTQfrCUwUAABrnFj0G4A7TOYiIiHapaagqetx0iL7yXAEAgK5A5Foo1pjOQUREOe/trkDkW6ZD9IcnC8D75dLuqHUJgITpLERElLO6VOWr75dLu+kg/eHJAgAATXMLV4jo903nICKi3CSQ/2qsirxmOkd/ebYAAED9pujPFMj6uy0REZHPKJ6q31x4q+kYAyGmAwzUmNr20SG13wAw1HQWIiLKCTssDUxdV1XwrukgA+HpPQAAsKGi4D1RXGU6BxER5Yxyrw9/wAcFAADqq6IPi8ivTOcgIiLfu6OhMvqg6RDp4IsCAAD5TvvVAqw2nYOIiHxK8GZ7W9t1pmOki+fPAdhd2cLWI9WSlwEMNp2FiIh8pdlS54R1VYPrTAdJF9/sAQCA+rlFawG9DICazkJERL6hjugVfhr+gM8KAAA0VBb9USE/NZ2DiIj8QYAfeukpf73luwIAAI2bC/8b0L+YzkFERB6neKp+eORG0zHc4MsCgPniJMN6CSANpqMQEZFXaVMoqF/FTLFNJ3GDPwsAgA2zB29XxfkAOkxnISIiz+m0EPjy2vKiraaDuMW3BQAAGqsir0Gk3HQOIiLyFoFWrqssXG46h5t8XQAAoKEiskQUi03nICIij1AsrK8sutd0DLf5vgAAgGVHvgnIS6ZzEBFRdlPg+YIRketN58iEnCgAdfOkSxXnAtpkOgsREWUraZCQnL9qpiRMJ8mEnCgAANBYFdnoqHwBwA7TWYiIKOu0WKJnN1wV2WQ6SKbkTAEAgKaq6NsKnAegy3QWIiLKGklx5MvrKqJvmQ6SSTlVAACgsTL6D1GZBd4umIiIAIXK7Pq5kadNB8m0nCsAAFBfFfmdAD80nYOIiAwTfL+hKnK/6Rgm+OppgH2iKqW1sV8BcpnpKERElHkq+F3jnMglEMnJPcI5uQcAACCiQwPR2RDk3G4fIiLCP4LJyKxcHf5ALu8B2KVs8fbBaoeeBXCM6SxEROQ+AVanYJ+yvrI4p68Ky/kCAAAltTtKxAm+CMEo01mIiMhVG+EET2qYm5/z94XJ3UMAu2msGNJoiXUmgBbTWYiIyDXNqvIFDv+dWAB2WVdZuNyx9AsA4qazEBFR2rUDenZjVeQ100GyBQvAbprmFL0gjpwLoNN0FiIiSpsOR3FWQ2XRv0wHySYsAHupnxt5WkXOBe8WSETkB0kRndlUFX3GdJBswwKwH40VkSdF8VUAKdNZiIio32wVXFZfUfSE6SDZiAXgAOqrog8rZDYAx3QWIiLqMwV0TmNF9Pemg2QrFoAeNFZG7gMwz3QOIiLqExXF3IbKortMB8lmLAAH0VAZrVbItaZzEBFR7yj0u/VV0RrTObIdC0AvNFZGbgXwI9M5iIioZ6L4QWNl0U2mc3gB7wTYByU1rd8WyE9N5yAion0J5Kb6ysh3TOfwCu4B6IPGyqKbVPXbpnMQEdFeBN/j8O8b7gHoh5Ka2BwBqsECRURkmqrKtY1VkdtMB/EaFoB+KquNX6KqvwIQNJ2FiChH2QK9qr6y6F7TQbyIBWAASmtjM6H4NYCQ6SxERDkmAcUlDVXRh0wH8SoWgAEqq2k5U2E9CCDfdBYiohzRpY5+pXFu0WOmg3gZC0AalNTEPiXA4wCiprMQEfmbtAlwbn1l5G+mk3gdC0CalFW3naDi/AXAUNNZiIh8qtlSPXNdVdHzpoP4AQtAGo2vaZvhqPMnCEaZzkJE5DMbHbG+2FRRuNJ0EL/gZWxptK6ycLnj2CcDeNt0FiIiv1BgFZzgSRz+6cUCkGZNVxc32LD/QwA+e5qIaIAU+Du6Uqc0zM1vMp3Fb3gIwCWTl2q4fWvsTkAuM52FiMiLRORX+cMKy1fNlITpLH7EAuAmVSmriX9fBd8D/62JiHpLRXFjfWXkBxBR02H8ikMpA0pq4l8X6B0AwqazEBFluQREZjdURJaYDuJ3LAAZMr42dpqj+AOAYtNZiIiy1A4VnN9YEV1mOkguYAHIoLGLYpMCjvwJ0BLTWYiIsos0OKpnNlVFeRVVhvAqgAxaPye6WhUnA3jRdBYiomyhwPOW6Ekc/pnFApBhjVWRjeM2Rz4hkJtMZyEiygJ3FA6PnLquIrrZdJBcw0MABpXWxL8G6GIABaazEBFlWKeIVtVXFN1jOkiuYgEwrKQ6fpwIHga01HQWIqIMWS9qXVBfVfiK6SC5jIcADGusiryWcJwTADxpOgsRkdsE+udk2JnG4W8e9wBkC1UpqY19SyA/AYsZEfmPCuRn9ZsL/wvzxTEdhlgAsk5ZbetZqrIEvF8AEflHqyN6eVNF0SOmg9BHWACyUNmiliPUsR4GcIzpLEREA6JY4wDn8xK/7MNdzVmofs7gfxdox8mqwrNjici7BHe2t7cdz+GfnbgHIMuVVcfOV8EdAIaZzkJE1EvNKqhorIj+3nQQOjAWAA8oqY4fIuLcC8gZprMQEfVI8HQSga9vqCh4z3QU6hkLgFeoSklN2zwRvQnAINNxiIj2khTFT+q3RG7kWf7ewALgMeNrY8c4wG+hmGI6CxHRLm87Yl3SVFG40nQQ6j2eBOgx6yqibyU7Ih+DYgEANZ2HiHKdLmlvazuBw997uAfAw0pq458X1V8BOMR0FiLKOVugemVDVdHjpoNQ/3APgIc1VkSedALWdAB/NJ2FiHLKHxCSKRz+3sY9AD5RWhO7EEANgOGmsxCRb22E4uqGquhDpoPQwHEPgE80VEYftASTAV1iOgsR+Y4CuiQZdiZz+PsH9wD4UGl17AIIbgfPDSCigXsHDr7RMDf6T9NBKL24B8CHGqqiD0kgedSuKwVs03mIyJNSArlJ8yPHcfj7E/cA+Ny4hW3TLcu5A8AM01mIyDNWWrCuWldZuNx0EHIPC0AOmLFYQ9vs2HUC+R6AAtN5iChbSZsC/904vPB2zBTuPfQ5FoAcMqa2fXRIU/8LyKWmsxBRVlEAD8EJ3tAwN7/JdBjKDBaAHDSuOnaqJVgA4BjTWYjIMNVXLQvXrKsoes50FMosngSYg5qqos+M2xyZpirXAGgxnYeIjHgfQHnDlujHOPxzE/cA5LjSO+OjkNQbAVwJIGA6DxG5rhOCX7bH2/530w2HtJkOQ+awABAAoGRx61Fiy40ALjSdhYjcIk84dmpe09XFDaaTkHksALSHspr4ZxX6CwBTTWchorRZCQfX8Hp+2h0LAO1rqQbKtsYuU+D7gIwzHYeI+ksaoJjfsKXw15gvjuk0lF1YAOiAJi/VcPvW+OUAfgDeVpjIS7Yq9BfIj97WOEs6TYeh7MQCQAc16ucbC/MLC+YK5DsAik3nIaIDigmkxkp1/aRu3rBW02Eou7EAUK9NvHtLtKtrUCWLAFHWiQmkJoXUTesri3eYDkPewAJAfbZbEfg2gCGm8xDlMA5+6jcWAOq3klt2FCMv+E1RzAMw1HQeohyyDYLbxEouqC8fypt5Ub+wANCAldyredLeNhOi/wVgouk8RD62URSLEUzewsFPA8UCQOkzX63SEbEzVeQ7AnzcdBwiH6lTlYVBu3BR3TzpMh2G/IEFgFxRVt16CkSuV+Bs8JkTRP0iwDOqektDZfQJiKjpPOQvLADkqrE1zWUBDXwTgtkACkznIfKABIDH1HF+2SdcMA4AAAQGSURBVDh38Eumw5B/sQBQRkxYEBuRCqJCgCoAI03nIco6ik0CLNKw1DZcFdlkOg75HwsAZdSuuwueA+AbAD4D/gwSLQdwR7IzsmTDddJhOgzlDm58yZjSmtaJAmuWQmcDGGY6D1EGtQB4QGxZWH915E3TYSg3sQCQcaN+vrEwv6DgQhG5AsAp4M8l+ZMC+CdU7ukKFj70frm0mw5EuY0bWsoq46vbD7cl9VWBVQ5oqek8RAMlwHuA/FrUvmtd1eA603mIurEAUHaar1bJqLbTxdFLIXIuoIWmIxH1QQzQR2FZSxo2Fj7NR/FSNmIBoKy3806DsdMhcimAcwCETWci2g8bwDNQWVKA9odXVY2Mmw5E1BMWAPKU0Qtbh4UCcgEUMwX4FICA6UyU01IAlkF1aXKQ/mHD7MHbTQci6i0WAPKsMXe1DA11Bc6C4EJAPwfuGaDMsAG8qCoPShi/5zX75FUsAOQLJbfsKJa80Jegeg6AzwGIms5EvtIK4ElA/iiBxON8EA/5AQsA+c9SDZRtiZ0Msc5S6NkAjjYdiTypHsDfoPpEwYjok6tmSsJ0IKJ0YgEg3ytZ3HoUbOsMqHO6iPUpXlFAB/D/27uflqiiOIzj39+dUVLHGqMhEbVAiXCgiFkoJu3qxUQtWrTvPYRCb8E3ECQtAkNdGG20P4yiWIFO4Vgz2jgz52kxLXQTaMkdur8P3MXlbJ7lcw6/e24F7JXEXKTwfP3B+Y9xB3LuLHkBcImSn1Vn9VtlEtk9U7iL2S18kDCpmqA3mL2QmOu5lFnwXb5LEi8ALtHy0zuZA+ueQJqScRu4gw8T/q+awFvEa4z5emd46VP7Lsm8ADh3RH56J7NP9yRoCmMcGAcuxJ3LnUoZWDKxiNl8tVpZ2H7cX407lHPtwguAc3/yRNFwf+V6Omhc2AStQjAGdMSczB1XB1ZMLAW0KGxp837mPWaKO5hz7coLgHMnVHimjr165VrTrAAqYBSAm0Am7mwJUQE+gFalaDkiLB/Wepf9V7rOnYwXAOf+kaGn1YGOlMaCyJtpDMgDN/A7CU6rZrCm1s5+VcZKKrBa/Jp553frO/f3vAA4d5YkG5k5GGzQHI1MI0Y0KjQKjPx+kl4OvgPrGEUFK5qFNZkV0/VUsfiw67Mf4Tt3drwAOBej4ZlyX7qZHiQdroANSQyChjAbQFxG5DByQBR31hMKiBJGCWMb6QvYlmArMn2iEW2GRn1r41FfOe6gziWVFwDn2t2sUldL1VwUyFlauRC4iCmLoiyRsogsImvQLaMXOAd0IXowOml9xXC0QLTWjzsAfh55D8Ae4hCjCuwDNRM/BPsYZYwywcoQdi2yssGuGlYKEaWNUs+OH9M7195+AXLs5rPHK/ouAAAAAElFTkSuQmCC"
                          />
                        </defs>
                      </svg>
                    </p>
                    <p class="email-recipient">
                      <span>to: </span>
                      <span
                        v-for="(item, index) in content.recipients"
                        :key="index"
                        v-text="item + (content.recipients.length - 1 !== index ? ',' : '')"
                      />
                    </p>
                  </div>
                </div>
                <div>
                  <div class="span-date-wrap">
                    <span class="span-date">{{ parseDate(content.date) }}</span>
                    <span class="span-date">{{ parseDateTime(content.date) }}</span>
                  </div>
                  <div class="email-settings">
                    <button v-click-outside="closeTools" class="button-comment" @click="openTools">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 11.6521C9 11.7443 8.96488 11.8328 8.90237 11.898C8.83986 11.9633 8.75507 11.9999 8.66667 11.9999C8.57826 11.9999 8.49348 11.9633 8.43096 11.898C8.36845 11.8328 8.33333 11.7443 8.33333 11.6521C8.33333 11.5598 8.36845 11.4714 8.43096 11.4061C8.49348 11.3409 8.57826 11.3043 8.66667 11.3043C8.75507 11.3043 8.83986 11.3409 8.90237 11.4061C8.96488 11.4714 9 11.5598 9 11.6521ZM9 11.6521H8.66667M12.3333 11.6521C12.3333 11.7443 12.2982 11.8328 12.2357 11.898C12.1732 11.9633 12.0884 11.9999 12 11.9999C11.9116 11.9999 11.8268 11.9633 11.7643 11.898C11.7018 11.8328 11.6667 11.7443 11.6667 11.6521C11.6667 11.5598 11.7018 11.4714 11.7643 11.4061C11.8268 11.3409 11.9116 11.3043 12 11.3043C12.0884 11.3043 12.1732 11.3409 12.2357 11.4061C12.2982 11.4714 12.3333 11.5598 12.3333 11.6521ZM12.3333 11.6521H12M15.6667 11.6521C15.6667 11.7443 15.6315 11.8328 15.569 11.898C15.5065 11.9633 15.4217 11.9999 15.3333 11.9999C15.2449 11.9999 15.1601 11.9633 15.0976 11.898C15.0351 11.8328 15 11.7443 15 11.6521C15 11.5598 15.0351 11.4714 15.0976 11.4061C15.1601 11.3409 15.2449 11.3043 15.3333 11.3043C15.4217 11.3043 15.5065 11.3409 15.569 11.4061C15.6315 11.4714 15.6667 11.5598 15.6667 11.6521ZM15.6667 11.6521H15.3333M20 11.6521C20 15.8779 16.4178 19.3042 12 19.3042C11.2331 19.3052 10.4694 19.2001 9.72889 18.9916C8.68512 19.7576 7.41184 20.1057 6.14222 19.972C6.00106 19.9578 5.8605 19.9377 5.72089 19.9117C6.15899 19.373 6.4582 18.7265 6.59022 18.0335C6.67022 17.6096 6.472 17.1978 6.17511 16.8963C4.82667 15.5273 4 13.6825 4 11.6521C4 7.42628 7.58222 4 12 4C16.4178 4 20 7.42628 20 11.6521Z"
                          stroke="#696F79"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span v-if="commentsCount > 0" class="comments-counter">{{ commentsCount }}</span>
                    </button>
                    <div class="highlight-wrapper">
                      <div
                        v-show="showTools"
                        class="tools"
                      >
                        <span
                          class="item"
                          @click.stop="openComments"
                        >
                          <svg
                            fill="none"
                            height="23"
                            viewBox="0 0 23 23"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 11.6521C9 11.7443 8.96488 11.8328 8.90237 11.898C8.83986 11.9633 8.75507 11.9999 8.66667 11.9999C8.57826 11.9999 8.49348 11.9633 8.43096 11.898C8.36845 11.8328 8.33333 11.7443 8.33333 11.6521C8.33333 11.5598 8.36845 11.4714 8.43096 11.4061C8.49348 11.3409 8.57826 11.3043 8.66667 11.3043C8.75507 11.3043 8.83986 11.3409 8.90237 11.4061C8.96488 11.4714 9 11.5598 9 11.6521ZM9 11.6521H8.66667M12.3333 11.6521C12.3333 11.7443 12.2982 11.8328 12.2357 11.898C12.1732 11.9633 12.0884 11.9999 12 11.9999C11.9116 11.9999 11.8268 11.9633 11.7643 11.898C11.7018 11.8328 11.6667 11.7443 11.6667 11.6521C11.6667 11.5598 11.7018 11.4714 11.7643 11.4061C11.8268 11.3409 11.9116 11.3043 12 11.3043C12.0884 11.3043 12.1732 11.3409 12.2357 11.4061C12.2982 11.4714 12.3333 11.5598 12.3333 11.6521ZM12.3333 11.6521H12M15.6667 11.6521C15.6667 11.7443 15.6315 11.8328 15.569 11.898C15.5065 11.9633 15.4217 11.9999 15.3333 11.9999C15.2449 11.9999 15.1601 11.9633 15.0976 11.898C15.0351 11.8328 15 11.7443 15 11.6521C15 11.5598 15.0351 11.4714 15.0976 11.4061C15.1601 11.3409 15.2449 11.3043 15.3333 11.3043C15.4217 11.3043 15.5065 11.3409 15.569 11.4061C15.6315 11.4714 15.6667 11.5598 15.6667 11.6521ZM15.6667 11.6521H15.3333M20 11.6521C20 15.8779 16.4178 19.3042 12 19.3042C11.2331 19.3052 10.4694 19.2001 9.72889 18.9916C8.68512 19.7576 7.41184 20.1057 6.14222 19.972C6.00106 19.9578 5.8605 19.9377 5.72089 19.9117C6.15899 19.373 6.4582 18.7265 6.59022 18.0335C6.67022 17.6096 6.472 17.1978 6.17511 16.8963C4.82667 15.5273 4 13.6825 4 11.6521C4 7.42628 7.58222 4 12 4C16.4178 4 20 7.42628 20 11.6521Z"
                              stroke="#696F79"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Comment
                        </span>
                      </div>
                      <div
                        v-if="showComments"
                        v-click-outside="closeComments"
                        class="tools comments"
                        style="height: 300px"
                      >
                        <div v-if="commentsLoadFlag" class="comments-loader-wrapper">
                          <loader :load-flag="commentsLoadFlag" />
                        </div>
                        <div
                          v-else
                          ref="commentScroll"
                          class="scroll-area"
                        >
                          <div
                            v-for="(comment, index) in comments"
                            :key="index"
                            class="comment"
                          >
                            <span class="comment-date">{{ commentDate(comment) }}</span>
                            <div class="comment-avatar">
                              <svg
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx="12"
                                  cy="12"
                                  fill="#F8FCFC"
                                  r="12"
                                />
                                <path
                                  d="M12.0001 4.11328C9.5477 4.11328 7.54297 6.11801 7.54297 8.57042C7.54297 11.0228 9.5477 13.0276 12.0001 13.0276C14.4525 13.0276 16.4573 11.0228 16.4573 8.57042C16.4573 6.11801 14.4525 4.11328 12.0001 4.11328Z"
                                  fill="#E6E7E9"
                                />
                                <path
                                  d="M20.534 16.6731C20.4037 16.3451 20.23 16.0389 20.0345 15.7546C19.0357 14.2675 17.4941 13.2834 15.757 13.0428C15.5399 13.0209 15.301 13.0646 15.1273 13.1959C14.2153 13.8738 13.1296 14.2237 12.0005 14.2237C10.8714 14.2237 9.78571 13.8738 8.87373 13.1959C8.7 13.0646 8.46115 12.9991 8.24403 13.0428C6.50694 13.2834 4.94357 14.2675 3.96646 15.7546C3.77104 16.0389 3.59732 16.3669 3.46706 16.6731C3.40194 16.8043 3.42363 16.9574 3.48876 17.0886C3.66248 17.3948 3.8796 17.701 4.07502 17.9634C4.379 18.3789 4.70472 18.7507 5.07386 19.1006C5.37784 19.4068 5.72525 19.6911 6.07271 19.9754C7.78806 21.2657 9.85087 21.9436 11.9788 21.9436C14.1067 21.9436 16.1696 21.2656 17.8849 19.9754C18.2323 19.713 18.5797 19.4068 18.8838 19.1006C19.2312 18.7507 19.5786 18.3789 19.8826 17.9634C20.0997 17.6791 20.2952 17.3948 20.4689 17.0886C20.5774 16.9574 20.5991 16.8043 20.534 16.6731Z"
                                  fill="#E6E7E9"
                                />
                              </svg>
                            </div>
                            <div class="comment-content">
                              <p class="comment-email">
                                {{ comment.email }}
                              </p>
                              <p class="comment-text">
                                {{ comment.text }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="new-comment">
                          <div class="new-comment-wrap">
                            <svg
                              fill="none"
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                fill="#F8FCFC"
                                r="12"
                              />
                              <path
                                d="M12.0001 4.11328C9.5477 4.11328 7.54297 6.11801 7.54297 8.57042C7.54297 11.0228 9.5477 13.0276 12.0001 13.0276C14.4525 13.0276 16.4573 11.0228 16.4573 8.57042C16.4573 6.11801 14.4525 4.11328 12.0001 4.11328Z"
                                fill="#E6E7E9"
                              />
                              <path
                                d="M20.5349 16.6731C20.4046 16.3451 20.2309 16.0389 20.0355 15.7546C19.0367 14.2675 17.4951 13.2834 15.758 13.0428C15.5408 13.0209 15.302 13.0646 15.1283 13.1959C14.2163 13.8738 13.1306 14.2237 12.0015 14.2237C10.8723 14.2237 9.78668 13.8738 8.8747 13.1959C8.70098 13.0646 8.46212 12.9991 8.24501 13.0428C6.50791 13.2834 4.94455 14.2675 3.96744 15.7546C3.77202 16.0389 3.59829 16.3669 3.46804 16.6731C3.40291 16.8043 3.42461 16.9574 3.48973 17.0886C3.66346 17.3948 3.88058 17.701 4.076 17.9634C4.37998 18.3789 4.70569 18.7507 5.07484 19.1006C5.37882 19.4068 5.72623 19.6911 6.07368 19.9754C7.78904 21.2657 9.85185 21.9436 11.9798 21.9436C14.1077 21.9436 16.1705 21.2656 17.8859 19.9754C18.2333 19.713 18.5807 19.4068 18.8847 19.1006C19.2321 18.7507 19.5796 18.3789 19.8836 17.9634C20.1007 17.6791 20.2962 17.3948 20.4698 17.0886C20.5784 16.9574 20.6001 16.8043 20.5349 16.6731Z"
                                fill="#E6E7E9"
                              />
                            </svg>
                            <input
                              v-model="$v.commentText.$model"
                              placeholder="Add a comment..."
                              type="text"
                              @keyup.enter="addComment"
                            >
                            <button
                              class="send-comment-btn"
                              :disabled="$v.commentText.$invalid"
                              @click="addComment"
                            >
                              <svg
                                fill="none"
                                height="20"
                                viewBox="0 0 20 20"
                                width="20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.10525 2.28867C2.98136 2.27111 2.85503 2.28483 2.7378 2.32858C2.62056 2.37233 2.51613 2.44471 2.43402 2.53915C2.35191 2.63358 2.29474 2.74705 2.26771 2.86923C2.24068 2.99141 2.24465 3.11842 2.27925 3.23867L3.69325 8.16367C3.78314 8.47669 3.97245 8.75196 4.2326 8.94788C4.49274 9.1438 4.80958 9.24973 5.13525 9.24967H11.2503C11.4492 9.24967 11.6399 9.32869 11.7806 9.46934C11.9212 9.60999 12.0003 9.80076 12.0003 9.99967C12.0003 10.1986 11.9212 10.3893 11.7806 10.53C11.6399 10.6707 11.4492 10.7497 11.2503 10.7497H5.13525C4.80958 10.7496 4.49274 10.8555 4.2326 11.0515C3.97245 11.2474 3.78314 11.5227 3.69325 11.8357L2.27925 16.7617C2.24465 16.8819 2.24068 17.0089 2.26771 17.1311C2.29474 17.2533 2.35191 17.3668 2.43402 17.4612C2.51613 17.5556 2.62056 17.628 2.7378 17.6718C2.85503 17.7155 2.98136 17.7292 3.10525 17.7117C8.80145 16.9026 14.1265 14.4116 18.3983 10.5577C18.4764 10.4873 18.5389 10.4014 18.5817 10.3053C18.6245 10.2093 18.6466 10.1053 18.6466 10.0002C18.6466 9.89503 18.6245 9.79107 18.5817 9.69502C18.5389 9.59898 18.4764 9.513 18.3983 9.44267C14.1264 5.58877 8.80143 3.09776 3.10525 2.28867Z"
                                  fill="#082655"
                                />
                              </svg>
                            </button>
                          </div>

                          <div v-if="$v.commentText.$error" class="error-wrap">
                            <span v-if="!$v.commentText.required" class="error">Field is required</span>
                            <span v-if="!$v.commentText.minLength" class="error">Minimum length is {{
                              $v.commentText.$params.minLength.min
                            }}</span>
                            <span v-if="!$v.commentText.maxLength" class="error">Maximum length is {{
                              $v.commentText.$params.maxLength.max
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="email-content indent">
                <div class="email-text" v-html="sanitizedContent" />
                <div v-if="content.tags && content.tags.length" class="tag-wrap">
                  <span
                    v-for="(tag, index) in content.tags"
                    :key="index"
                    class="tag"
                    v-text="tag"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="content.attachments && content.attachments.length"
              class="email-bottom indent"
            >
              <p class="email-attached-text" v-text="`${content.attachments.length} attached files`" />
              <div class="attachment-wrapper">
                <Attachments
                  v-for="(attachment, index) in content.attachments"
                  :key="attachment.id + index"
                  :attachment="attachment"
                  :without-preview="true"
                  :with-recognition-text="true"
                  @downloadFile="$emit('downloadFile', $event)"
                />
              </div>
            </div>
          </div>
        </vue-custom-scrollbar>
        <div class="email-bottom-panel">
          <button
            class="btn resend-btn"
            :disabled="!checkContent"
            @click.prevent.stop="openMetaInfoPopup"
          >
            <span class="btn-span">Show meta info</span>
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.75 1.625C16.0484 1.625 16.3345 1.74353 16.5455 1.9545C16.7565 2.16548 16.875 2.45163 16.875 2.75V16.25C16.875 16.5484 16.7565 16.8345 16.5455 17.0455C16.3345 17.2565 16.0484 17.375 15.75 17.375H2.25C1.95163 17.375 1.66548 17.2565 1.4545 17.0455C1.24353 16.8345 1.125 16.5484 1.125 16.25V2.75C1.125 2.45163 1.24353 2.16548 1.4545 1.9545C1.66548 1.74353 1.95163 1.625 2.25 1.625H15.75ZM2.25 0.5C1.65326 0.5 1.08097 0.737053 0.65901 1.15901C0.237053 1.58097 0 2.15326 0 2.75L0 16.25C0 16.8467 0.237053 17.419 0.65901 17.841C1.08097 18.2629 1.65326 18.5 2.25 18.5H15.75C16.3467 18.5 16.919 18.2629 17.341 17.841C17.7629 17.419 18 16.8467 18 16.25V2.75C18 2.15326 17.7629 1.58097 17.341 1.15901C16.919 0.737053 16.3467 0.5 15.75 0.5L2.25 0.5Z"
                fill="#082655"
              />
              <path
                d="M10.0462 7.9115L7.46995 8.23438L7.3777 8.66188L7.88395 8.75525C8.2147 8.834 8.27995 8.95325 8.20795 9.28288L7.3777 13.1844C7.15945 14.1935 7.49582 14.6683 8.2867 14.6683C8.89982 14.6683 9.61195 14.3848 9.93482 13.9955L10.0338 13.5275C9.80882 13.7255 9.48032 13.8043 9.26207 13.8043C8.9527 13.8043 8.8402 13.5871 8.92007 13.2046L10.0462 7.9115ZM10.1249 5.5625C10.1249 5.86087 10.0064 6.14702 9.79544 6.35799C9.58446 6.56897 9.29831 6.6875 8.99995 6.6875C8.70158 6.6875 8.41543 6.56897 8.20445 6.35799C7.99347 6.14702 7.87495 5.86087 7.87495 5.5625C7.87495 5.26413 7.99347 4.97798 8.20445 4.767C8.41543 4.55603 8.70158 4.4375 8.99995 4.4375C9.29831 4.4375 9.58446 4.55603 9.79544 4.767C10.0064 4.97798 10.1249 5.26413 10.1249 5.5625Z"
                fill="#082655"
              />
            </svg>
          </button>
          <div class="holder-select-messanger">
            <CustomSelect
              v-model="currentFormat"
              :default="formats[0].name"
              :type-select="'filterMessengers'"
              :custom-class="'select-databases top'"
              :options="formats"
            />
          </div>
          <button
            class="btn resend-btn"
            :disabled="!checkContent"
            @click.prevent.stop="$emit('export', content.id, currentFormat)"
          >
            <span class="btn-span">Export</span>
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_10735_2971)">
                <path
                  d="M17.6032 6.21577L13.4133 10.4268V7.87912C12.7606 7.77396 10.1499 7.58455 8.21306 10.8059L7.96015 11.2269L7.87605 10.7424C7.87605 10.7214 7.32857 7.71061 9.89731 5.5842C9.93974 5.54176 11.0324 4.53477 13.4133 4.55258V2.04688L17.6032 6.21577Z"
                  fill="#082655"
                />
                <path
                  d="M13.6933 1.76579C13.5798 1.65289 13.4095 1.61928 13.2616 1.68076C13.1137 1.74225 13.0173 1.88675 13.0173 2.04688V4.16246C10.8757 4.24795 9.80355 5.13569 9.63969 5.28328C8.5593 6.16993 7.82163 7.40536 7.5537 8.77708C7.41974 9.43978 7.39589 10.1198 7.48293 10.7903L7.48324 10.7926C7.48401 10.7985 7.48494 10.8045 7.48602 10.8103L7.56997 11.2947C7.59831 11.4579 7.72515 11.5862 7.88792 11.6167C8.05069 11.647 8.21517 11.573 8.3005 11.4312L8.55341 11.0102C9.32886 9.72042 10.2954 8.86551 11.4263 8.46919C11.9365 8.28876 12.4768 8.20962 13.0173 8.23595V10.4268C13.0173 10.5874 13.1141 10.732 13.2625 10.7934C13.4109 10.8546 13.5815 10.8203 13.6947 10.7065L17.8848 6.49548C18.0393 6.3403 18.0386 6.08924 17.8833 5.93484L13.6933 1.76579ZM13.8103 9.46627V7.87912C13.8103 7.68444 13.669 7.51858 13.4768 7.4876C13.1375 7.43293 12.2329 7.34635 11.1641 7.72084C10.0235 8.12072 9.03677 8.90702 8.22431 10.0624C8.22198 9.68263 8.25791 9.30349 8.33163 8.93102C8.57262 7.71248 9.18467 6.68923 10.1506 5.88961C10.1591 5.88264 10.1673 5.87536 10.1751 5.86762C10.2039 5.84114 11.2112 4.93311 13.4109 4.94906C13.5165 4.94984 13.6181 4.90849 13.6932 4.83399C13.7682 4.75965 13.8103 4.65837 13.8103 4.55259V3.00075L17.0431 6.21733L13.8103 9.46627Z"
                  fill="#082655"
                />
                <path
                  d="M16.547 13.3248C16.328 13.3248 16.1505 13.5023 16.1505 13.7213V15.3972C16.1498 16.0539 15.6176 16.586 14.9611 16.5866H1.98238C1.32572 16.586 0.793728 16.0539 0.792953 15.3972V5.95113C0.793728 5.29462 1.32572 4.76248 1.98238 4.7617H4.72442C4.94341 4.7617 5.1209 4.58422 5.1209 4.36523C5.1209 4.14639 4.94341 3.96875 4.72442 3.96875H1.98238C0.888046 3.96999 0.00123899 4.85695 0 5.95113V15.3972C0.00123899 16.4915 0.888046 17.3783 1.98238 17.3796H14.9611C16.0555 17.3783 16.9423 16.4915 16.9435 15.3972V13.7213C16.9435 13.5023 16.7659 13.3248 16.547 13.3248Z"
                  fill="#082655"
                />
              </g>
              <defs>
                <clipPath id="clip0_10735_2971">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <MetaInfoPopup
      ref="emailMetaInfoPopup"
      :meta-info="metaInfo"
      :info-type="'email'"
    />
  </div>
</template>

<script>
import MetaInfoPopup from '@/components/popups/MetaInfoPopup';
import parseDate from '@/mixins/parseDate';
import parseDateTime from '@/mixins/parseTime';
import Loader from '@/components/loader/Loader.vue';
import moment from 'moment/moment';
import {maxLength, minLength, required} from 'vuelidate/lib/validators';
import Attachments from '@/components/attachments/Attachments.vue';
import settings from '@/mixins/scrollSettings';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import CustomSelect from '@/components/inputs/CustomSelect.vue';
import sanitizeHtml from '@/utils/sanitizeHtml';

export default {
  name: 'SpecificEmailMessage',
  components: {
    CustomSelect,
    Attachments,
    Loader,
    MetaInfoPopup,
    vueCustomScrollbar
  },
  mixins: [parseDate, parseDateTime, settings],
  props: {
    content: {
      type: Object,
      required: true
    },
    loadFlag: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      metaInfo: {},
      commentsLoadFlag: true,
      showTools: false,
      showComments: false,
      commentsCount: 0,
      commentText: '',
      comments: [],
      formats: [
        {name: 'xml', id: 0},
        {name: 'csv', id: 1},
        {name: 'pdf', id: 2},
      ],
      currentFormat: 'xml',
    };
  },
  validations() {
    return {
      commentText: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(1000)
      },
    };
  },
  computed: {
    checkContent() {
      return this.content && !!this.content.id;
    },
    sanitizedContent() {
      return sanitizeHtml(this.content.content);
    }
  },
  watch: {
    showComments(newVal) {
      if (!newVal) {
        this.commentText = '';
        this.$v.$reset();
      }
    },
    content(newVal) {
      if (newVal) {
        this.getComments();
        this.getMetaInfo();
      }
    }
  },
  methods: {
    formatCheck(url) {
      if (url) {
        const arr = url.type.split('/');
        return `.${arr[1]}`;
      }
    },
    openMetaInfoPopup() {
      this.$refs.emailMetaInfoPopup.openPopup();
    },
    getMetaInfo() {
      this.$load(async () => {
        await this.$api.cases.getEmailMetaInfo(this.$route.params.slug, this.content.id).then((res) => {
          this.metaInfo = res.data.body;
        });
      });
    },
    openTools() {
      this.showTools = !this.showTools;
    },
    closeTools() {
      this.showTools = false;
    },
    openComments() {
      this.getComments();
      this.showComments = true;
      this.closeTools();
    },
    closeComments() {
      this.showComments = false;
    },
    commentDate(comment) {
      return moment.utc(comment.createdAt).local().format('MM DD, HH:mm');
    },
    addComment() {
      if (this.commentText) {
        this.$load(async () => {
          await this.$api.cases
            .createCommentForEmail(this.$route.params.slug, this.content.id, {text: this.commentText})
            .then(() => {
              this.comments.push({
                email: this.$store.getters['profile/user'].email,
                createdAt: new Date(),
                id: this.comments.length + Math.random(),
                text: this.commentText,
              });

              this.commentsCount++;
              this.$v.$reset();
            });

          this.commentText = '';
          this.scrollCommentsToBottom();
        });
      }
    },
    scrollCommentsToBottom() {
      setTimeout(() => {
        if (this.$refs.commentScroll) {
          this.$refs.commentScroll.scrollTo(0, 9999);
        }
      }, 0);
    },
    getComments() {
      this.commentsLoadFlag = true;
      this.comments = [];

      this.$load(async () => {
        const res = await this.$api.cases.getCommentListForEmail(this.$route.params.slug, this.content.id);

        this.comments = res.data.body;
        this.commentsCount = res.data.body.length;

        this.commentsLoadFlag = false;
        this.scrollCommentsToBottom();
      });
    },
  }
};
</script>

<style>
.email-text > table[role="presentation"] > tbody > tr > td:not(.container) {
  display: none;
}

.email-text table[role="presentation"] .btn.btn-primary {
  padding: unset;
  background: unset;
  border-radius: unset;
  display: block;
  color: unset;
  border: unset;
  outline: none;
  cursor: pointer;
  min-width: unset;
  transition: all .5s;
  text-decoration: none;
}
</style>

<style scoped>

.indent {
  margin-left: 35px;
}

.email-content-wrap {
  padding-right: 10px;
  margin-left: 30px;
  margin-bottom: 100px;
  overflow-y: auto;
  overflow-x: hidden;
  height: fit-content;
  min-height: 400px;
}

.email-top {
  padding-bottom: 24px;
  border-bottom: 1px solid #D7DCE6;
  margin-bottom: 24px;
}

.email-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}

.email-sender-wrap {
  display: flex;
  align-items: flex-start;
  max-width: calc(100% - 85px);
}

.email-sender_image {
  width: 21px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
}

.email-sender_image img {
  width: 100%;
  height: 100%;
}

.email-sender {
  max-width: calc(100% - 35px);
}

.email-sender_name-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}

.email-sender_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 24px);
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--secondary-black-color);
}

p.email-recipient {
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  color: var(--secondary-text-color);
  margin-bottom: 0;
}

p.email-recipient span:not(:last-child) {
  margin-right: 4px;
}

.email-content {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-right: 50px;
}

.email-text {
  width: calc(100% - 110px);
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--secondary-text-color);
  word-break: break-word;
  text-align: left;
  white-space: pre-line;
}

.tag-wrap {
  max-width: 100px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.tag-wrap .tag {
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  padding: 2px 4px;
  background-color: #F1105F;
  text-transform: capitalize;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-right: 8px;
}

.email-bottom:not(:last-child) {
  margin-bottom: 24px;
}

.email-attached-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--secondary-black-color);
  margin-bottom: 16px;
}

.email-sender_icon {
  margin-left: 8px;
  width: 16px;
  height: 16px;
}

.span-date-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 5px;
}

.span-date:not(:last-child) {
  margin-bottom: 3px;
}

.span-date {
  display: inline-block;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 500;
  color: var(--secondary-text-color);
}

.email-settings {
  position: relative;
}

.email-bottom-panel {
  position: fixed;
  bottom: 0;
  width: 54%;
  background-color: var(--accent-color);
  padding: 24px 43px;
  min-height: 83px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 0 4px 10px rgba(77, 106, 147, 0.15);
}

.btn.resend-btn {
  padding: 8px 15px;
  width: auto;
  min-width: 140px;
  border-color: var(--case-filters-border-color);
  background-color: var(--white-color);
  font-size: 12px;
  line-height: 14px;
  color: var(--secondary-text-color);
}

.btn.resend-btn svg path {
  fill: var(--accent-color);
}

.btn.resend-btn:hover {
  color: var(--accent-color);
  border-color: var(--accent-color);
}

.btn.resend-btn:hover svg path {
  fill: var(--accent-color);
}

.btn.resend-btn:not(:last-child) {
  margin-right: 10px;
}

.button-comment {
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  justify-content: center;
  width: 100%;
}

.button-comment:hover svg path {
  stroke: var(--accent-color);
}

.button-comment:hover .comments-counter {
  color: var(--accent-color);
}

.button-comment svg path, .button-comment .comments-counter {
  transition: all 0.2s;
}

.button-comment .comments-counter {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #696f79;
}

.tools {
  position: absolute;
  z-index: 200;
  top: 50%;
  right: 0;
  justify-content: center;
  align-items: center;
  transition: 0.2s all;
  border: 1px solid var(--case-btn-border-color);
  border-radius: 8px;
  padding: 8px;
  background-color: var(--white-color);
  font-size: 12px;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: var(--secondary-text-color);
  gap: 6px;
  transition: 0.2s all;
}

.item svg path {
  transition: 0.2s all;
}

.item:not(:last-child) {
  margin-bottom: 12px;
}

.item:hover {
  color: var(--accent-color);
}

.item:hover svg path {
  stroke: var(--accent-color);
}

.new-comment-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.new-comment {
  width: 100%;
}

.new-comment .error-wrap {
  margin-top: 6px;
  margin-left: 10px;
}

.new-comment .error {
  display: inline;
}

.comments {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 403px;
}

.comments input {
  border: none;
  width: 100%;
  height: 25px;
  padding: 0;
  font-size: 12px;
  line-height: 19px;
}

.comments .send-comment-btn {
  padding: 0;
  border: none;
  background-color: transparent;
}

.comments .send-comment-btn:disabled svg path {
  fill: var(--background-button-disabled-color);
}

.comments .send-comment-btn:not(:disabled):hover svg path {
  opacity: 0.5;
}

.comments .send-comment-btn svg path {
  transition: all 0.5s;
}

.comments .comment {
  display: flex;
  position: relative;
  margin-bottom: 38px;
}

.comments .comment:last-child {
  margin-bottom: 20px;
}

.comments .comment-date {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-10%, 50%);
  font-size: 10px;
  color: var(--light-gray);
}

.comments .comment-avatar {
  margin-right: 8px;
}

.comments .comment-content {
  width: 90%;
}

.comments .comment-email {
  overflow-x: hidden;
  margin-bottom: 0;
  max-width: 280px;
  font-size: 14px;
  font-weight: 600;
  line-height: 23px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comments .comment-text {
  overflow: hidden;
  margin: 0;
  font-size: 12px;
  font-weight: 500;
}

.comments .scroll-area {
  width: 100%;
  max-height: 296px;
  overflow-y: auto;
  margin-bottom: 15px;
}

/* width */
.comments .scroll-area::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.comments .scroll-area::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 15px;
}

/* Handle */
.comments .scroll-area::-webkit-scrollbar-thumb {
  background: var(--accent-color);
  border-radius: 15px;
}

button[disabled] {
  cursor: not-allowed;
}

.comments-loader-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-bg {
  height: 100%;
  transform: none;
  position: static;
}

.specific-message {
  min-height: inherit;
  height: 100%;
}

.select-databases {
  position: relative;
}

.select-databases >>> .selected {
  margin-right: 10px;
  width: 140px;
  height: 35px;
  color: var(--secondary-text-color);
}

.select-databases >>> .items {
  top: 0;
  transform: translateY(calc(-100% - 30px));
}

</style>
